import { FC, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { useAppSelector } from '../../redux'
import { ROUTES, useSegment } from '../../utils'
import { StyledCheckoutView } from '.'

const CheckoutView: FC = () => {
  const location = useLocation()
  const history = useHistory()
  const { track } = useSegment()
  const { user, loading: uLoad } = useAppSelector((state) => state.user)
  const { cid }: any = useParams()

  useEffect(() => {
    const search = new URLSearchParams(location.search)
    const params = Object.fromEntries(search)
    const { courseId, courseName, courseSlug } = params

    if (uLoad) {
      return
    }

    if (!user || !courseId || !courseName || !courseSlug) {
      return history.push(ROUTES.home)
    }

    track('Checked Out Course', {
      course_id: courseId,
      course_title: courseName
    })

    const checkoutURL = [
      'https://pay.socialcurator.com/checkout/',
      cid,
      `?email=${encodeURIComponent(user.email)}`,
      `&user_id=${encodeURIComponent(user.id)}`,
      `&stripe_cus=${encodeURIComponent(user.stripeCustomerId)}`,
      `&course_name=${courseName}`,
      `&course_slug=${courseSlug}`,
      `&course_id=${courseId}`
    ].join('')

    window.location.href = checkoutURL
  }, [user, cid, location.search, uLoad])

  return (
    <>
      <Helmet title="Loading checkout..." />
      <StyledCheckoutView />
    </>
  )
}

export default CheckoutView
